import { IonCardContent, useIonToast } from '@ionic/react';
import { keyOutline, phonePortraitOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import { DataProvider } from '../../../../library/DataProvider';
import { LoginPostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

interface Props {
    loginSuccess: any,
    loginNoActivation: any
}

const LoginForm: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const formLogin = useAppSelector(state => state.login)
    const { form_loading, resp } = formLogin

    const [submit, setSubmit] = useState(false);

    const [form, setForm] = useState({
        mobile: { value: "", validation: { required: true }, error: "" },
        password: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            setSubmit(true);

            dispatch(LoginPostAction(form.mobile.value, form.password.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading && submit) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })
                    
                    formProvider.reset();

                    doRespDone();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })

                    if (resp.activation_remained !== undefined) {
                        props.loginNoActivation(resp.uid, resp.activation_remained);
                        return;
                    }
                }
            }
        }

        formDone();
    }, [form_loading])

    const doRespDone = async () => {
        props.loginSuccess(resp.profile, resp.access_token, resp.refresh_token);
        
        setSubmit(false)
    }

    return <IonCardContent>
        <form onSubmit={formSubmitHandler}>
            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider} />

            <InputItem name="password" type="password" label="رمز عبور" icon={keyOutline} ltr provider={formProvider} />

            <ActionButton text="ورود اعضا" loading={form_loading} />
        </form>
    </IonCardContent>;
}
export default LoginForm